module.exports = __webpack_public_path__ + "img/nl.84600bca.svg";